import { ControllerFlowAPI, IHttpClient } from '@wix/yoshi-flow-editor';

type IsOrderProvisionedResponse = {
  isProvisioned: boolean;
  hasGroup: boolean;
};

type ErrorHandler = ControllerFlowAPI['errorHandler'];

export class BenefitPrograms {
  constructor(private httpClient: IHttpClient, private errorHandler: ErrorHandler) {}

  public async isOrderProvisioned(orderId: string) {
    try {
      const response = await this.errorHandler.withErrorHandler(
        () =>
          this.httpClient.get<IsOrderProvisionedResponse>(
            `/_serverless/pricing-plans-bpp/is-order-provisioned/${orderId}`,
          ),
        { errorCodesMap: {} },
      );
      const { isProvisioned, hasGroup } = response.data;
      return isProvisioned && hasGroup;
    } catch (err) {
      this.errorHandler.getResolvedError(err);
      throw err;
    }
  }

  public async isEcomOrderProvisioned(orderId: string) {
    try {
      const response = await this.errorHandler.withErrorHandler(
        () =>
          this.httpClient.get<IsOrderProvisionedResponse>(
            `/_serverless/pricing-plans-bpp/is-ecom-order-provisioned/${orderId}`,
          ),
        { errorCodesMap: {} },
      );
      const { isProvisioned, hasGroup } = response.data;
      return isProvisioned && hasGroup;
    } catch (err) {
      this.errorHandler.getResolvedError(err);
      throw err;
    }
  }
}
